// extracted by mini-css-extract-plugin
export default {"gdpr__consent-text":"gdpr__consent-text__uyyTA","gdpr__instructions":"gdpr__instructions__4gHNi"};